export var UpdateStatus;
(function (UpdateStatus) {
    UpdateStatus[UpdateStatus["DownloadingFailure"] = -5] = "DownloadingFailure";
    UpdateStatus[UpdateStatus["InstallationStopped"] = -4] = "InstallationStopped";
    UpdateStatus[UpdateStatus["InstallationError"] = -3] = "InstallationError";
    UpdateStatus[UpdateStatus["IncompatiblePackage"] = -2] = "IncompatiblePackage";
    UpdateStatus[UpdateStatus["Error"] = -1] = "Error";
    UpdateStatus[UpdateStatus["OK"] = 0] = "OK";
    UpdateStatus[UpdateStatus["DownloadingPackage"] = 1] = "DownloadingPackage";
    UpdateStatus[UpdateStatus["CheckingPackage"] = 2] = "CheckingPackage";
    UpdateStatus[UpdateStatus["PreparingForUpgrade"] = 3] = "PreparingForUpgrade";
    UpdateStatus[UpdateStatus["Upgrading"] = 4] = "Upgrading";
    UpdateStatus[UpdateStatus["MovingData"] = 5] = "MovingData";
    UpdateStatus[UpdateStatus["Reloading"] = 6] = "Reloading";
    UpdateStatus[UpdateStatus["Upgraded"] = 7] = "Upgraded";
})(UpdateStatus || (UpdateStatus = {}));
export var UpdateState;
(function (UpdateState) {
    UpdateState[UpdateState["WaitingForUser"] = 1] = "WaitingForUser";
    UpdateState[UpdateState["Downloading"] = 2] = "Downloading";
    UpdateState[UpdateState["Unpackaging"] = 3] = "Unpackaging";
    UpdateState[UpdateState["CheckingApplicability"] = 4] = "CheckingApplicability";
    UpdateState[UpdateState["MigratingData"] = 5] = "MigratingData";
    UpdateState[UpdateState["CreatingBackup"] = 6] = "CreatingBackup";
    UpdateState[UpdateState["Deploying"] = 7] = "Deploying";
    UpdateState[UpdateState["Installing"] = 8] = "Installing";
    UpdateState[UpdateState["Removing"] = 9] = "Removing";
    UpdateState[UpdateState["Error"] = 10] = "Error";
    UpdateState[UpdateState["ReadyToDownload"] = 11] = "ReadyToDownload";
    UpdateState[UpdateState["PreparingSystem"] = 12] = "PreparingSystem";
    UpdateState[UpdateState["CheckingPackageIntegrity"] = 13] = "CheckingPackageIntegrity";
    UpdateState[UpdateState["CheckingIntegrity"] = 14] = "CheckingIntegrity";
    UpdateState[UpdateState["UndoingInstallation"] = 15] = "UndoingInstallation";
    UpdateState[UpdateState["Installed"] = 16] = "Installed";
})(UpdateState || (UpdateState = {}));
export var UserInput;
(function (UserInput) {
    UserInput[UserInput["Ignore"] = 0] = "Ignore";
    UserInput[UserInput["Cancel"] = 1] = "Cancel";
    UserInput[UserInput["Install"] = 2] = "Install";
})(UserInput || (UserInput = {}));
export class UpdateProgressInfo {
    constructor() {
        /**
         * Map of resource names
         *
         * As key we have language code as specified in RFC 4646. As value we have description of update in specified language.
         * https://learn.microsoft.com/en-us/aspnet/core/fundamentals/localization?view=aspnetcore-7.0
         * https://www.ietf.org/rfc/rfc4646.txt
         * ex. pl-PL, en-US
         */
        this.UpdatedResourceName = new Map();
        /**
         * Percentage of installation progress
         */
        this.Percentage = 0;
        /**
         * Percentage of total update progress
         */
        this.PercentageTotal = 0;
        /**
         * Current state of update
         */
        this.Status = UpdateStatus.Error;
        /**
         * Number of current installing update
         */
        this.UpdateNumber = 1;
        /**
         * Number of all updates to install
         */
        this.AvailableUpdates = 1;
    }
}
export class DownloadProgressInfo {
    constructor() {
        /**
         * Map of resource names
         *
         * As key we have language code as specified in RFC 4646. As value we have description of update in specified language.
         * https://learn.microsoft.com/en-us/aspnet/core/fundamentals/localization?view=aspnetcore-7.0
         * https://www.ietf.org/rfc/rfc4646.txt
         * ex. pl-PL, en-US
         */
        this.UpdatedResourceName = new Map();
        /**
         * Percentage of download progress
         */
        this.Percentage = 0;
        /**
         * Percentage of total update progress
         */
        this.PercentageTotal = 0;
        /**
         * Speed of download in Megabits per second
         */
        this.SpeedMbps = 0;
        /*
        * Current task realted to download software
        */
        this.CurrentTask = DownloadTask.Unknown;
        this.DownloadOnly = false;
    }
}
export class BulkUpdateResult {
    constructor() {
        /**
         * General status of bulk update
         */
        this.BulkUpdateStatus = BulkUpdateStatus.Success;
        /**
         * Map of device update results, as key we have device guid
         */
        this.DevicesUpdateResults = new Map();
    }
}
export var BulkUpdateStatus;
(function (BulkUpdateStatus) {
    BulkUpdateStatus[BulkUpdateStatus["Success"] = 0] = "Success";
    BulkUpdateStatus[BulkUpdateStatus["PartialSuccess"] = 1] = "PartialSuccess";
    BulkUpdateStatus[BulkUpdateStatus["UpdatesNotFound"] = 2] = "UpdatesNotFound";
    BulkUpdateStatus[BulkUpdateStatus["CannotUnpairRetransmitters"] = 3] = "CannotUnpairRetransmitters";
    BulkUpdateStatus[BulkUpdateStatus["CannotPairRetransmitters"] = 4] = "CannotPairRetransmitters";
})(BulkUpdateStatus || (BulkUpdateStatus = {}));
export var BulkUpdateDeviceStatus;
(function (BulkUpdateDeviceStatus) {
    BulkUpdateDeviceStatus[BulkUpdateDeviceStatus["Unknown"] = 0] = "Unknown";
    BulkUpdateDeviceStatus[BulkUpdateDeviceStatus["Updated"] = 1] = "Updated";
    BulkUpdateDeviceStatus[BulkUpdateDeviceStatus["InsufficientConnection"] = 2] = "InsufficientConnection";
    BulkUpdateDeviceStatus[BulkUpdateDeviceStatus["Error"] = 3] = "Error";
    BulkUpdateDeviceStatus[BulkUpdateDeviceStatus["UnknownError"] = 4] = "UnknownError";
    BulkUpdateDeviceStatus[BulkUpdateDeviceStatus["ControllerSoftwareTooOld"] = 5] = "ControllerSoftwareTooOld";
})(BulkUpdateDeviceStatus || (BulkUpdateDeviceStatus = {}));
export var DownloadTask;
(function (DownloadTask) {
    DownloadTask[DownloadTask["Unknown"] = 0] = "Unknown";
    DownloadTask[DownloadTask["DownloadingUpdate"] = 1] = "DownloadingUpdate";
    DownloadTask[DownloadTask["DownloadingInstaller"] = 2] = "DownloadingInstaller";
    DownloadTask[DownloadTask["CheckingUpdate"] = 3] = "CheckingUpdate";
    DownloadTask[DownloadTask["UpdateDownloadedAndChecked"] = 4] = "UpdateDownloadedAndChecked";
})(DownloadTask || (DownloadTask = {}));
export var UpdateErrorCode;
(function (UpdateErrorCode) {
    UpdateErrorCode[UpdateErrorCode["DeviceIsUpToDate"] = 0] = "DeviceIsUpToDate";
    UpdateErrorCode[UpdateErrorCode["CannotFindDevice"] = 1] = "CannotFindDevice";
    UpdateErrorCode[UpdateErrorCode["UnsupportedApiVersion"] = 2] = "UnsupportedApiVersion";
    UpdateErrorCode[UpdateErrorCode["UnsupportedDevice"] = 3] = "UnsupportedDevice";
    UpdateErrorCode[UpdateErrorCode["CannotGetFirmwareVersion"] = 4] = "CannotGetFirmwareVersion";
    UpdateErrorCode[UpdateErrorCode["CannotGetUpdates"] = 5] = "CannotGetUpdates";
    UpdateErrorCode[UpdateErrorCode["CannotProcessUpdate"] = 6] = "CannotProcessUpdate";
    UpdateErrorCode[UpdateErrorCode["UpdateActionsNotSupported"] = 7] = "UpdateActionsNotSupported";
    UpdateErrorCode[UpdateErrorCode["UnsupportedExtensionVersion"] = 8] = "UnsupportedExtensionVersion";
    UpdateErrorCode[UpdateErrorCode["UpdatesPartiallyInstalled"] = 9] = "UpdatesPartiallyInstalled";
    UpdateErrorCode[UpdateErrorCode["RetransmitterFound"] = 10] = "RetransmitterFound";
    UpdateErrorCode[UpdateErrorCode["ProtocolRadioUnsupported"] = 11] = "ProtocolRadioUnsupported";
    UpdateErrorCode[UpdateErrorCode["FeatureUnsupportedInCurrentVersion"] = 12] = "FeatureUnsupportedInCurrentVersion";
    UpdateErrorCode[UpdateErrorCode["CannotGetUpdatesBranch"] = 13] = "CannotGetUpdatesBranch";
    UpdateErrorCode[UpdateErrorCode["CannotSetUpdatesBranch"] = 14] = "CannotSetUpdatesBranch";
    UpdateErrorCode[UpdateErrorCode["UpdateAlreadyDownloaded"] = 15] = "UpdateAlreadyDownloaded";
    UpdateErrorCode[UpdateErrorCode["UpdateDownloadFailed"] = 16] = "UpdateDownloadFailed";
    UpdateErrorCode[UpdateErrorCode["UpdateAlreadyInstalled"] = 17] = "UpdateAlreadyInstalled";
    UpdateErrorCode[UpdateErrorCode["CannotGetCurrentControllerVersionTimeout"] = 18] = "CannotGetCurrentControllerVersionTimeout";
    UpdateErrorCode[UpdateErrorCode["CannotGetCurrentControllerVersion"] = 19] = "CannotGetCurrentControllerVersion";
    UpdateErrorCode[UpdateErrorCode["InstallerFileSignCheckFailed"] = 20] = "InstallerFileSignCheckFailed";
    UpdateErrorCode[UpdateErrorCode["UpdateFileSignCheckFailed"] = 21] = "UpdateFileSignCheckFailed";
    UpdateErrorCode[UpdateErrorCode["UpdateFileCheckFailed"] = 22] = "UpdateFileCheckFailed";
    UpdateErrorCode[UpdateErrorCode["UpdateInstallationFailed"] = 23] = "UpdateInstallationFailed";
})(UpdateErrorCode || (UpdateErrorCode = {}));
export var UpdateBranch;
(function (UpdateBranch) {
    UpdateBranch["Public"] = "public";
    UpdateBranch["Beta"] = "beta";
    UpdateBranch["Development"] = "dev";
})(UpdateBranch || (UpdateBranch = {}));
//# sourceMappingURL=IUpdatesService.js.map